import { PartialDeep } from "type-fest";
import _ from "lodash";
import { CartItemRequest } from "../product/types";

export type User = {
  id: number | null;
  customerId: number | null;
  customerNumber: string | null;
  customerName: string | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  defaultWarehouse: string | null;
  permissions: string[];
  isAdmin: boolean | null;
  defaultShipTo: string | null;
  cartItems: number | null;
  exclusiveCustomer: boolean | null;
  hasMostPurchased: boolean | null;
  hasDashboard: boolean | null;
  impersonatedCustomer: string | null;
  isSecondaryUser: boolean | null;
  isInternal: boolean | null;
  accountMenu: AccountMenu | null;
  menu: Menu;
  originalUserId: number;
  originalUserType: string | null;
  isZendeskCustomer: boolean;
  hasHoverRole: boolean;
  hasEagleViewAccess: boolean;
  shareCartItemDtos: CartItemRequest[];
};

export type Menu = {
  shopProductsVisible: boolean;
  menuItems: MenuItem[];
};

export type MenuItem = {
  id: number;
  name: string;
  seName: string;
  subCategories: MenuItem[];
};

export type AccountMenu = {
  myDashboardVisible: boolean;
  onlineBillPayVisible: boolean;
  customerAccountVisible: boolean;
  userProfileVisible: boolean;
  manageUsersVisible: boolean;
  orderNotificationsVisible: boolean;
  shipToVisible: boolean;
};

function userModel(data: PartialDeep<User>): User {
  data = data || {};

  return _.defaults(data, {
    id: null,
    customerId: null,
    customerNumber: null,
    customerName: null,
    firstName: null,
    lastName: null,
    email: null,
    defaultWarehouse: null,
    permissions: [],
    isAdmin: null,
    menu: {
      shopProductsVisible: false,
      menuItems: [],
    },
    defaultShipTo: null,
    cartItems: null,
    exclusiveCustomer: null,
    hasMostPurchased: false,
    hasDashboard: false,
    impersonatedCustomer: null,
    isSecondaryUser: null,
    isInternal: null,
    accountMenu: {
      myDashboardVisible: false,
      onlineBillPayVisible: false,
      customerAccountVisible: false,
      userProfileVisible: false,
      manageUsersVisible: false,
      orderNotificationsVisible: false,
      shipToVisible: false,
    },
    originalUserId: 0,
    originalUserType: null,
    isZendeskCustomer: false,
    hasHoverRole: false,
    hasEagleViewAccess: false,
    shareCartItemDtos: [],
  });
}

export default userModel;
